export const rankTrainingErrors = (totalErrors) => {
    if (totalErrors === 0)
        return 5;
    if (totalErrors <= 1)
        return 4;
    if (totalErrors <= 2)
        return 3;
    if (totalErrors <= 3)
        return 2;
    if (totalErrors <= 4)
        return 1;
    return 0;
};
